export default "__VITE_ASSET__1789c28c__"